//
// common
//////////////////////////////////////////////////////////////////////
$(function(){
  // アンカーリンク
  /////////////////////////////////
  $("[data-anchorLink]").click(function() {
    // スクロールの速度
    var speed = 400; // ミリ秒で記述
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $('body,html').animate({
        scrollTop: position
    }, speed, 'swing');
    return false;
  });
});

//
// interview
//////////////////////////////////////////////////////////////////////
$(function(){

	// 「続きを読む」ボタン
	/////////////////////////////////
	var initQuestionAnswerLength = 1,
			closeClass = "js-close";

	// 初期非表示
	$("[data-interviewItem]").each(function() {
		$(this).find("[data-questionAnswer__item").each(function(index) {
			if(index + 1 > initQuestionAnswerLength) {
				$(this).hide();
			}
		});	
	});
	$("[data-interviewBiography]").hide();

	// ボタンクリック
	$("[data-interviewMore]").click(function() {
		var $parent = $(this).parent(),
				parentTop = $parent.offset().top,
				$questionAnswer = $parent.find("[data-questionAnswer__item]"),
				$biography = $parent.find("[data-interviewBiography]");

		$(this).toggleClass(closeClass);

		if($(this).hasClass(closeClass)) {
			$questionAnswer.fadeIn();
			$biography.fadeIn();
		} else {
			$questionAnswer.each(function(index) {
				if(index + 1 > initQuestionAnswerLength) {
					$(this).fadeOut();
				}
			});
			$biography.fadeOut();
			$("html,body").animate({scrollTop:parentTop},500);
		}
	});
});

//
// interview
//////////////////////////////////////////////////////////////////////
$(function(){
  $("[data-jobDescription__toggleButton]").click(function() {
    var activeClass = "js-active";

    $(this).toggleClass(activeClass);
    if($(this).hasClass(activeClass)) {
      $(this).next("[data-jobDescription__description]").slideDown();
    } else {
      $(this).next("[data-jobDescription__description]").slideUp();
    }
  });
});





